<template>
    <v-form-element :id="id" :label="label" :form="form" :input-name="inputName" :with-counter="withCounter" :max-length="maxLength" :container-class-name="containerClassName" :label-container-class-name="labelContainerClassName" :input-container-class-name="inputContainerClassName" :helper="helper">
        <vue-phone-number-input
            :id="id"
            :placeholder="getPlaceholder()"
            :type="type"
            :class="[{'has-error': this.form.errors.has(this.inputName)}, className]"
            :required="required"
            :default-country-code="form[inputCountryName]"
            :only-countries="['BE', 'FR', 'DE', 'LU', 'GB', 'NL', 'CH']"
            v-model="model"
            ref="input"
            @update="onUpdate"
        />
    </v-form-element>
</template>

<script>

    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';
    import FormElement from './Element';
    import mixin from './mixin';

    export default {
        components: {
            'v-form-element': FormElement,
            'vue-phone-number-input': VuePhoneNumberInput
        },
        mixins: [mixin],
        props: {
            phoneCountry: {
                type: String,
                default: 'BE'
            },
            inputCountryName: {
                type: String,
                default: 'phone_country'
            }
        },    
        methods: {
            onUpdate(data) {
                this.model = data.formatNational;
                this.form[this.inputCountryName] = data.countryCode;
                this.$emit('changed');
            }
        }
    }
</script>